<template>
  <div class="form-group row px-3">
    <input v-model="fromValue" placeholder="When..." class="form-control form-control-sm col-4 mr-2">
    <input v-model="toValue" placeholder="Then..." class="form-control form-control-sm col">
    <a class="btn btn-sm btn-danger ml-2 col-1" href="#" @click="$emit('removeMapping', input)"><i class="fas fa-times"></i></a>
  </div>
</template>

<script>
  export default {
    props: {
      input: Object
    },
    computed: {
      fromValue: {
        get: function() {
          return this.input.from
        },
        set: function(value){
          this.input.from = value
        }
      },
      toValue: {
        get: function() {
          return this.input.to
        },
        set: function(value){
          this.input.to = value
        }
      }
    }
  }
</script>